import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconProgress75: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconProgress75"><Path d="M12 19.25C16.0041 19.25 19.25 16.0041 19.25 12C19.25 7.99594 16.0041 4.75 12 4.75V12H4.75C4.75 16.0041 7.99594 19.25 12 19.25Z" fill="currentColor"/><Circle cx="12" cy="12" r="9.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconProgress75;
